
export const createPropaysForOptions = [
    {
        label: 'All Jobs',
        value: 'all_jobs',
    },
    // {
    //     label: 'Job Category',
    //     value: 'job_category',
    // },
    // {
    //     label: 'Crew',
    //     value: 'crew',
    // },
    {
        label: 'Crew Lead',
        value: 'crew_leads',
    }
];
export const crewMembersOptions = [
    {
        label: 'User 1',
        value: 'User 1',
    },
    {
        label: 'User 2',
        value: 'User 2',
    },
    {
        label: 'User 3',
        value: 'User 3',
    },
    {
        label: 'User 4',
        value: 'User 4',
    },
];
export const leadMembersForOptions = [
    {
        label: 'Lead 1',
        value: 'Lead 1',
    },
    {
        label: 'Lead 2',
        value: 'Lead 2',
    },
    {
        label: 'Lead 3',
        value: 'Lead 3',
    },
    {
        label: 'Lead 4',
        value: 'Lead 4',
    },
];
export const jobFromConnectorOptions = [
    {
        label: 'Connector 1',
        value: 'Connector 1',
    },
    {
        label: 'Connector 2',
        value: 'Connector 2',
    },
];
export const isAndIsNotOptions = [
    {
        label: 'Is',
        value: 'Is',
    },
    {
        label: 'Is Not',
        value: 'Is Not',
    },
];
export const jobStateOptions = [
    {
        label: 'Moving',
        value: 'Moving',
    },
    {
        label: 'Install',
        value: 'Install',
    },
];

export const importedFromOptions = [
    // {
    //     label: 'Imported from other system',
    //     value: 'imported',
    // },
    {
        label: 'Selected from user list',
        value: 'selected_from_user_list',
    },
];
export const showManagerFromInList = {
        'imported_from_other_system': 'Imported from other system',
        'selected_from_user_list':'Selected from user list'
    }

export const showPropaysForInList = {
        'all_jobs': 'All Jobs',
        'Job Category':'job_category',
        'Crew': 'crew',
        'crew_leads': 'Crew Lead',
    }

export const showPropaysBudgetOptionInList = {
        'revenue': 'Contract Price',
        'labor_budget':'Labor Budget',
        'hours_budget': 'Hours Budget'
    }

export const showPropaysBudgetMultiplyInList = {
    'increase': 'Increase',
    'multiply':'Multiply',
    'decrease':'Decrease',
    'keep_the_same': 'Keep the Same'
}

export const increaseDecreaseOptions = [
    {
        label: 'Increase',
        value: 'increase',
    },
    {
        label: 'Decrease',
        value: 'decrease',
    },
    {
        label:'Keep the same',
        value:'keep_the_same'
    }
];

export const propayBudgetOption = [
    {
        label: 'Contract Price',
        value: 'revenue',
    },
    {
        label: 'Labor Budget',
        value: 'labor_budget',
    },
    {
        label: 'Hours Budget',
        value: 'hours_budget',
    },
];
export const increaseDecreasePercentOptions = [
    {
        label: '5%',
        value: '5',
    },
    {
        label: '10%',
        value: '10',
    },
];

export const devideBonusByOptions = [
    {
        label: 'Hours Worked',
        value: 'hours_worked',
    },
    {
        label: 'Set Percentage',
        value: 'set_percentage',
    },
];

export const distributeBudgetOptions = [
    {
        label: 'Equally',
        value: 'equaly',
    },
    {
        label: 'Weighted by Wage',
        value: 'weighted_by_wage',
    },
];

export const listEmployeesOptions = [
    {
        label: 'Manager 1',
        value: 'M1',
    },
    {
        label: 'Manager 2',
        value: 'M2',
    },
    {
        label: 'Manager 3',
        value: 'M3',
    },
    {
        label: 'Manager 4',
        value: 'M4',
    },
];
export const importedEmployeesOptions = [
    {
        label: 'Imported Manager 1',
        value: 'IM1',
    },
    {
        label: 'Imported Manager 2',
        value: 'IM2',
    },
    {
        label: 'Imported Manager 3',
        value: 'IM3',
    },
    {
        label: 'Imported Manager 4',
        value: 'IM4',
    },
];

export const propayTitleOptions = [
    { value: 'Parent Job', label: 'Parent Job' },
    { value: 'Child Job', label: 'Child Job' },
    { value: 'Parent Job > Child Job', label: 'Parent Job > Child Job'},
    { value: 'Job Category', label: 'Job Category'},
    { value: 'Address', label: 'Address'},
    { value: 'Customer Name', label: 'Customer Name'},
  ];
